var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
export var convertInviteeToParam = function (invitee) {
    /* @TODO remove all useless fields when v1 event api is deprecated
    All that is necessary is either a user_id, email, or space_id
    */
    var baseParams = {
        name: invitee.name,
        display_name: invitee.name,
        is_organizer: invitee.organizer || false,
        is_resource: false,
        conflicts: [],
        is_external: false,
    };
    if (invitee.user_id) {
        return __assign(__assign({}, baseParams), { user_id: invitee.user_id, email: invitee.email });
    }
    return __assign(__assign({}, baseParams), { 
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        email: invitee.email, user_id: invitee.user_id });
};
export var convertSpaceToInvitee = function (space) {
    return {
        space_id: space.id,
        email: getCalendarMailboxAddress(space),
        is_resource: true,
        is_external: false,
        is_organizer: false,
    };
};
export var convertUserToInvitee = function (user) {
    var _a;
    return {
        name: user.name || undefined,
        avatar: user.avatar || undefined,
        user_id: user.id || null,
        email: (_a = user.primaryEmail) === null || _a === void 0 ? void 0 : _a.email,
    };
};
export var convertEventTypeToEventDataResponse = function (event) {
    return {
        created_at: event.created_at,
        creation_type: event.creation_type,
        creator_email: event.creator_email,
        creator_id: event.creator_id,
        description: event.description,
        end: event.end,
        ended_at: event.ended_at,
        id: event.id,
        invitees: event.invitees.map(function (invitee) {
            var _a;
            return ({
                email: invitee.email,
                name: (_a = invitee.user) === null || _a === void 0 ? void 0 : _a.name,
                space_id: invitee.space_id,
                user_id: invitee.user_id,
                user: invitee.user,
            });
        }),
        is_all_day: event.is_all_day,
        location: event.location,
        organizer_email: event.organizer_email,
        remote_calendar_mailbox_address: event.remote_calendar_mailbox_address,
        remote_event_id: event.remote_event_id,
        remote_type: event.remote_type,
        show_as: event.show_as,
        space_id: event.space_id,
        space_invitees: event.space_invitees,
        start: event.start,
        started_at: event.started_at,
        status: event.status,
        title: event.title,
        uid: event.uid,
        updated_at: event.updated_at,
    };
};
export var getCalendarMailboxAddress = function (space) {
    var _a, _b;
    return (((_a = space === null || space === void 0 ? void 0 : space.calendar) === null || _a === void 0 ? void 0 : _a.spaceResourceEmail) || ((_b = space === null || space === void 0 ? void 0 : space.calendar) === null || _b === void 0 ? void 0 : _b.calendarId) || '');
};
export var isEmailAddress = function (text) {
    return text.includes('@') && text.includes('.');
};
export var conflictsWithExistingEvent = function (potentialEvent, existingEvents) {
    var startTime = potentialEvent.startTime, endTime = potentialEvent.endTime, ids = potentialEvent.ids;
    var conflicts = existingEvents.filter(function (existingEvent) {
        // Skip if potential event is in the list of events to ignore
        if (ids.includes(existingEvent.id)) {
            return false;
        }
        return (
        /* @TODO These is using the user's timezone instead of proper timezone */
        moment(startTime).isBefore(existingEvent.endTime) &&
            moment(endTime).isAfter(existingEvent.startTime));
    });
    return conflicts.map(function (conflict) { return ({
        eventConflictId: conflict.id,
        eventStartTime: conflict.startTime,
        eventEndTime: conflict.endTime,
    }); });
};
var ROBIN_STATIC_IMAGE_HOST = 'static.robinpowered.com';
/**
 * Creates a branded image thumb URL from a source image URL.
 * - URLs from static.robinpowered.com are run through the image server redirect with size=thumb.
 * - All other URLs (e.g. Google profile images) are returned as-is.
 * @param src - The source image URL to create a thumb for
 * @param imageServerUrl - The base URL for the image server
 * @returns A branded ImageThumbUrl or empty string if no source provided
 */
export var buildThumbImage = function (src, imageServerUrl) {
    if (!src)
        return '';
    try {
        var url = new URL(src);
        if (url.hostname === ROBIN_STATIC_IMAGE_HOST) {
            return "".concat(imageServerUrl, "/redirect?url=").concat(encodeURIComponent(src), "&size=thumb");
        }
        return src;
    }
    catch (_a) {
        return "".concat(imageServerUrl, "/redirect?url=").concat(encodeURIComponent(src), "&size=thumb");
    }
};
/* Calculates a value that increases but as a decreasing rate as the dynamicValue increases  */
export var calcLogarithmicGrowth = function (staticValue, plateau, speed, dynamicValue) {
    return staticValue + plateau * Math.log(1 + speed * dynamicValue);
};
export var formatCurrency = function (totalPrice) {
    return new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        currency: totalPrice.currencyCode,
        // can take a string, types are off: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format
    }).format(totalPrice.amountMajor);
};
export var isAbortError = function (error) {
    if (error instanceof DOMException) {
        return error.name === 'AbortError';
    }
    if (error instanceof Error) {
        return error.name === 'AbortError';
    }
    return false;
};
